// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1cf35075","455":"ab7e7c6f"}[chunkId] + ".chunk.js";
};